import { render, staticRenderFns } from "./MultiSelectSearchBox.vue?vue&type=template&id=b5d38680&scoped=true&"
import script from "./MultiSelectSearchBox.vue?vue&type=script&lang=ts&"
export * from "./MultiSelectSearchBox.vue?vue&type=script&lang=ts&"
import style0 from "./MultiSelectSearchBox.vue?vue&type=style&index=0&id=b5d38680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d38680",
  null
  
)

export default component.exports